import React from 'react';
import {
  CareType,
  ContractCareTypeScope,
  ContractCareTypeUtilization as ContractCareTypeUtilizationData,
} from '../../../graphQL';
import { Text } from '../../../globalStyles';
import { useCareTypeConfigContext } from '../../../Components/CareTypeConfigContext';
import { SessionsUtilizationWidget } from './SessionsWidget';
import { StudentCapacityWidget } from './StudentCapacityWidget';

type ContractUtilizationDashboardProps = {
  careType: CareType;
  scope: ContractCareTypeScope;
  utilization: ContractCareTypeUtilizationData;
};

export const ContractCareTypeUtilization = ({
  careType,
  scope,
  utilization,
}: ContractUtilizationDashboardProps) => {
  const { getCareTypeDisplay } = useCareTypeConfigContext();
  return (
    <div>
      <Text.h2>{getCareTypeDisplay(careType).serviceTitle} Utilization</Text.h2>
      <div className="flex justify-center">
        <StudentCapacityWidget
          max={scope.patients}
          remaining={utilization.studentCapacityRemaining}
          utilized={utilization.studentCapacityUtilized}
          careType={careType}
        />
        <div className="br b--gray" />
        <SessionsUtilizationWidget
          careType={careType}
          utilized={utilization.sessionsUtilized}
          scheduled={utilization.sessionsScheduled}
          remaining={utilization.sessionsRemaining}
          sessionsLimit={scope.sessions}
        />
      </div>
    </div>
  );
};
